import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da1889d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav nav-tabs mb-4 border-1 shadow-sm" }
const _hoisted_2 = {
  key: 1,
  class: "position-absolute top-ve start-100 translate-middle badge rounded-circle"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "unread messages", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLink, (nav) => {
      return (_openBlock(), _createElementBlock("li", {
        key: nav.name,
        class: "nav-item"
      }, [
        _createVNode(_component_router_link, {
          class: "nav-link",
          exact: "",
          "exact-active-class": "active",
          to: nav.path
        }, {
          default: _withCtx(() => [
            (nav.icon)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(nav.icon)
                }, null, 2))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(nav.name) + " ", 1),
            (nav.notification !== '')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createTextVNode(" + " + _toDisplayString(nav.notification) + " ", 1),
                  _hoisted_3
                ]))
              : _createCommentVNode("", true),
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}